import { FC } from 'react';
import { Box } from '@mui/material';
import MainLayout from 'src/pages/private';

const RawMaterialLogs: FC = () => {
  return (
    <MainLayout title="Raw Material Logs">
      <Box></Box>
    </MainLayout>
  );
};

export default RawMaterialLogs;
